<template>
    <main>
        <data-grid @search="search($event)" :data="pagination">
            <template #grid>
                <grid-table>
                    <template #head>
                        <grid-cell-header v-for="(h,i) in headers" :key="`h_${i}`">{{h}}</grid-cell-header>
                    </template>
                    <template #body>
                        <grid-row v-for="(sede, i) in pagination.data" :key="`d_${i}`">
                            <grid-cell class="text-center">
                                {{sede.CODIGO}}
                            </grid-cell>
                            <grid-cell>
                                {{sede.NOMBRE_SEDE}}
                            </grid-cell>
                            <grid-cell class="text-center">
                                <button class="btn btn-sm btn-icon btn-success" title="Seleccionar" @click="selected(i)">
                                    <i class="fas fa-check"></i>
                                </button>
                            </grid-cell>
                        </grid-row>
                    </template>
                </grid-table>
            </template>
        </data-grid>
    </main>
</template>

<script>
import sedeService from "../../services/sedeService";
import paginateMixin from "../../mixins/PaginateMixin";
import GridCell from "./utilities/DataGrid/GridCell";
import GridRow from "./utilities/DataGrid/GridRow";
import GridCellHeader from "./utilities/DataGrid/GridCellHeader";
import GridTable from "./utilities/DataGrid/GridTable";
import DataGrid from "./utilities/DataGrid/DataGrid";

export default {
    name: "SearchSedeComponent",
    mixins : [paginateMixin(sedeService)],
    components: {GridCell, GridRow, GridCellHeader, GridTable, DataGrid},
    data ()  {
        return {
            headers : ['Codigo', 'Descripcion', ''],
        }
    },
    mounted() {
        this.index();
    },
    methods : {
        selected(index){
            const selected = this.pagination.data[index];
            this.$emit('select', selected);
        }
    }
}
</script>

